import { render, staticRenderFns } from "./consultation.vue?vue&type=template&id=dc474fe2&scoped=true&"
import script from "./consultation.vue?vue&type=script&lang=js&"
export * from "./consultation.vue?vue&type=script&lang=js&"
import style0 from "./consultation.vue?vue&type=style&index=0&id=dc474fe2&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc474fe2",
  null
  
)

export default component.exports